// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__23DFO","right":"Footer_right__2iItl","buttons":"Footer_buttons__2-8R9"};